import React, { useContext } from 'react'
import PaymentInfoCustomer from './PaymentInfoCustomer'
import PaymentInfoInvoice from './PaymentInfoInvoice'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import PaymentButton from './PaymentButton'
import PayoutInfo from './PayoutInfo'
import Context from '../context/Context'

const PaymentInfo = () => {
  const context = useContext(Context)

  if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
    return (
      <div>
        <PaymentInfoCustomer />
        <PaymentInfoInvoice />
        <PaymentButton />
        {context.invoice.total_amount < 0 && <PayoutInfo />}
      </div>
    )
  } else {
    return (
      <div>
        <InvoiceStatus />
      </div>
    )
  }
}

export default PaymentInfo
